/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestPasswordReset.defs.js'
export { main as default } from './requestPasswordReset.defs.js'
